import * as THREE from 'three';

export default class Data {
    static instance;

    static getInstance() {
        return Data.instance;
    }

    constructor() {
        if (Data.instance) {
            return Data.instance;
        }
        Data.instance = this;

        this.sphereRadius = 1;

        this.creatureStats = {
            love: 50,
            food: 50,
            activity: 50
        };

        this.isCreatureActive = true;

        this.State = Object.freeze({
            NORMAL: 'normal',
            AWE: 'awe',
            HAPPY: 'happy',
            WHAT: 'what',
            LOVE: 'love',
            FULL: 'full',
            EXCITED: 'excited',
            WTF: 'wtf',
            SAD: 'sad',
            ANGRY: 'angry',
            HATE: 'hate',
            HUNGRY: 'hungry',
            DEPRESSED: 'depressed'
        });

        this.currentState = this.State.NORMAL;

        this.hairColors = Object.freeze({
            base: new THREE.Color("#ef59a0"),
            outer: new THREE.Color("#009e9a"),
            inner: new THREE.Color("#00dad6"),
            black: new THREE.Color('#565656'),
            grey: new THREE.Color('#8db07c'),
            blue: new THREE.Color('#677495'),
            red: new THREE.Color('#ff2222'),
            green: new THREE.Color('#46b910'),
            orange: new THREE.Color('#ffb910'),
        });

    }

}